import { time } from '@motionone/utils';
import { calcGeneratorVelocity } from '../utils/velocity.es.js';
import { spring } from '../spring/index.es.js';
var glide = function glide(_ref) {
  var _ref$from = _ref.from,
    from = _ref$from === void 0 ? 0 : _ref$from,
    _ref$velocity = _ref.velocity,
    velocity = _ref$velocity === void 0 ? 0.0 : _ref$velocity,
    _ref$power = _ref.power,
    power = _ref$power === void 0 ? 0.8 : _ref$power,
    _ref$decay = _ref.decay,
    decay = _ref$decay === void 0 ? 0.325 : _ref$decay,
    bounceDamping = _ref.bounceDamping,
    bounceStiffness = _ref.bounceStiffness,
    changeTarget = _ref.changeTarget,
    min = _ref.min,
    max = _ref.max,
    _ref$restDistance = _ref.restDistance,
    restDistance = _ref$restDistance === void 0 ? 0.5 : _ref$restDistance,
    restSpeed = _ref.restSpeed;
  decay = time.ms(decay);
  var state = {
    hasReachedTarget: false,
    done: false,
    current: from,
    target: from
  };
  var isOutOfBounds = function isOutOfBounds(v) {
    return min !== undefined && v < min || max !== undefined && v > max;
  };
  var nearestBoundary = function nearestBoundary(v) {
    if (min === undefined) return max;
    if (max === undefined) return min;
    return Math.abs(min - v) < Math.abs(max - v) ? min : max;
  };
  var amplitude = power * velocity;
  var ideal = from + amplitude;
  var target = changeTarget === undefined ? ideal : changeTarget(ideal);
  state.target = target;
  /**
   * If the target has changed we need to re-calculate the amplitude, otherwise
   * the animation will start from the wrong position.
   */
  if (target !== ideal) amplitude = target - from;
  var calcDelta = function calcDelta(t) {
    return -amplitude * Math.exp(-t / decay);
  };
  var calcLatest = function calcLatest(t) {
    return target + calcDelta(t);
  };
  var applyFriction = function applyFriction(t) {
    var delta = calcDelta(t);
    var latest = calcLatest(t);
    state.done = Math.abs(delta) <= restDistance;
    state.current = state.done ? target : latest;
  };
  /**
   * Ideally this would resolve for t in a stateless way, we could
   * do that by always precalculating the animation but as we know
   * this will be done anyway we can assume that spring will
   * be discovered during that.
   */
  var timeReachedBoundary;
  var spring$1;
  var checkCatchBoundary = function checkCatchBoundary(t) {
    if (!isOutOfBounds(state.current)) return;
    timeReachedBoundary = t;
    spring$1 = spring({
      from: state.current,
      to: nearestBoundary(state.current),
      velocity: calcGeneratorVelocity(calcLatest, t, state.current),
      damping: bounceDamping,
      stiffness: bounceStiffness,
      restDistance: restDistance,
      restSpeed: restSpeed
    });
  };
  checkCatchBoundary(0);
  return function (t) {
    /**
     * We need to resolve the friction to figure out if we need a
     * spring but we don't want to do this twice per frame. So here
     * we flag if we updated for this frame and later if we did
     * we can skip doing it again.
     */
    var hasUpdatedFrame = false;
    if (!spring$1 && timeReachedBoundary === undefined) {
      hasUpdatedFrame = true;
      applyFriction(t);
      checkCatchBoundary(t);
    }
    /**
     * If we have a spring and the provided t is beyond the moment the friction
     * animation crossed the min/max boundary, use the spring.
     */
    if (timeReachedBoundary !== undefined && t > timeReachedBoundary) {
      state.hasReachedTarget = true;
      return spring$1(t - timeReachedBoundary);
    } else {
      state.hasReachedTarget = false;
      !hasUpdatedFrame && applyFriction(t);
      return state;
    }
  };
};
export { glide };